import React from "react";
// import Button from '../Button';
import Spacing from "../Spacing";

export default function AboutStyle4({
  // thumbnailSrc,
  // miniTitle,
  id,
  title,
  subTitle,
  subTitle1,
  subTitle2,
  subTitle3,
  // btnText,
  // btnUrl,
}) {
  return (
    <div
      className="cs_about cs_style_1 "
      style={{ backgroundColor: "#fff" }}
      id={id}
    >
      <div className="container " style={{ padding: "30px 50px" }}>
        <div className="column align-items-right cs_gap_y_40 text_color font_title text_right " style={{textAlign: "-webkit-right"}}>
          <div className="col-lg-5 offset-lg-1">
            <div className="cs_section_heading cs_style_1 text_color_heading">
              <Spacing lg="10" md="5" />
              <h1
                className="cs_section_title cs_fs_50 mb-0 font_title_size"
                style={{ color: "#000", fontWeight: "900" }}
              >
                {title}
              </h1>
              <Spacing lg="24" md="24" />
            </div>
          </div>
          <div className="col-lg-6">
            <p
              className="text_right"
              style={{ color: "#000", textAlign: "right", lineHeight: "25px" }}
            >
              {subTitle} <br /> {subTitle1} <br /><br /> {subTitle2} <br /><br /> {subTitle3}
            </p>
          </div>

        </div>
      </div>
    </div>
  );
}
